import React__default from 'react';
import BsCol from 'reactstrap/lib/Col';

const Col = (props) => {
    return React__default.createElement(BsCol, Object.assign({}, props));
};

export { Col as default };
//# sourceMappingURL=Col.js.map
